import { DatePipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { CardRequestService } from '../../card-requests/card-request.service';
import { CardRequestsFilterService } from '../../card-requests/card-requests-filter.service';
import { CardRequestDetailService } from '../card-request-detail.service';

@Component({
    selector: 'app-card-request-detail-header',
    templateUrl: './card-request-detail-header.component.html',
    standalone: true,
    imports: [NgIf, ButtonDirective, TooltipModule, DatePipe, TranslateModule]
})
export class CardRequestDetailHeaderComponent {

    get translatedStatus(): string {
        return this.translateService.instant(`STATUS.${this.cardRequestDetailService.request.personQuery.status}`);
    }

    get translatedSubStatus(): string {
        const subStatus = `SUBSTATUS.${this.cardRequestDetailService.request.personQuery.substatus}`;
        return this.translateService.instant(subStatus);
    }

    constructor(
        public readonly cardRequestDetailService: CardRequestDetailService,
        public readonly cardRequestsFilterService: CardRequestsFilterService,
        public readonly cardRequestService: CardRequestService,
        private readonly router: Router,
        private readonly translateService: TranslateService
    ) { }

    navigateToRequests(): void {
        this.router.navigate(['/cards']).catch(error => { console.error(error); });
    }

    isValidBirthDate(): boolean {
        const strBirthDate = this.cardRequestDetailService.request.personQuery.birthDate;

        if (!strBirthDate) {
            return false;
        }

        const birthDate = new Date(strBirthDate);
        return !isNaN(birthDate.getTime());
    }

    protected temporarilyModifyReqRef(reqRef: string | null | undefined): string {
        if (!reqRef) return '';

        const start = reqRef.includes('SBD') ? 8 : 4;
        const length = 7;

        // Si no hay suficientes caracteres, devolver el original
        if (reqRef.length < start + length) return reqRef;

        return reqRef.substring(start, start + length);
    }
}
